var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import getMarginDimensions from "./mixins/getMarginDimensions";
var getCalc = function (from, to) {
    if (from !== "0" && to !== "0")
        return "calc((100% - " + from + ") - " + to + ")";
    if (from === "0" && to === "0")
        return "100%";
    return "calc(100% - " + (from === "0" ? to : from) + ")";
};
var maxHeight = function (_a) {
    var _b = _a.marginDimensions, top = _b.top, bottom = _b.bottom;
    return "max-height: " + getCalc(top, bottom) + ";";
};
var maxWidth = function (_a) {
    var _b = _a.marginDimensions, right = _b.right, left = _b.left;
    return "max-width: " + getCalc(left, right) + ";";
};
var hCenterAlignPositions = new Set(["top", "center", "bottom"]);
var leftAlignPositions = new Set(["bottom-left", "left", "top-left"]);
var styledLeft = function (_a) {
    var position = _a.position, full = _a.full, marginDimensions = _a.marginDimensions;
    if (full === "horizontal" || full === true || leftAlignPositions.has(position)) {
        return "left: " + marginDimensions.left + ";";
    }
    if (hCenterAlignPositions.has(position)) {
        return "left: 50%;";
    }
    return "";
};
var vCenterAlignPositions = new Set(["right", "center", "left"]);
var topAlignPositions = new Set(["top-left", "top", "top-right"]);
var styledTop = function (_a) {
    var position = _a.position, full = _a.full, marginDimensions = _a.marginDimensions;
    if (full === "vertical" || full === true || topAlignPositions.has(position)) {
        return "top: " + marginDimensions.top + ";";
    }
    if (vCenterAlignPositions.has(position)) {
        return "top: 50%;";
    }
    return "";
};
var rightAlignPositions = new Set(["top-right", "right", "bottom-right"]);
var styledRight = function (_a) {
    var position = _a.position, full = _a.full, marginDimensions = _a.marginDimensions;
    if (full === "horizontal" || full === true || rightAlignPositions.has(position)) {
        return "right: " + marginDimensions.right + ";";
    }
    return "";
};
var bottomAlignPositions = new Set(["bottom-right", "bottom", "bottom-left"]);
var styledBottom = function (_a) {
    var position = _a.position, full = _a.full, marginDimensions = _a.marginDimensions;
    if (full === "vertical" || full === true || bottomAlignPositions.has(position)) {
        return "bottom: " + marginDimensions.bottom + ";";
    }
    return "";
};
var transform = function (_a) {
    var full = _a.full, position = _a.position;
    var getValue = function () {
        var left = full !== true && full !== "horizontal" && hCenterAlignPositions.has(position);
        var top = full !== true && full !== "vertical" && vCenterAlignPositions.has(position);
        if (!left && !top)
            return "";
        if (left && !top)
            return "translateX(-50%)";
        if (!left && top)
            return "translateY(-50%)";
        return "translate(-50%, -50%)";
    };
    var value = getValue();
    return value && "transform: " + value + ";";
};
var boxShadow = function (_a) {
    var borderShadow = _a.borderShadow;
    return borderShadow && "box-shadow: 0px 2px 68px rgba(0, 0, 0, 0.288);";
};
var Container = styled.div.attrs(function (_a) {
    var theme = _a.theme, margin = _a.margin;
    return ({
        marginDimensions: getMarginDimensions(theme, margin),
    });
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: ", ";\n  display: flex;\n  z-index: 35;\n  outline: none;\n  pointer-events: all;\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", "\n"], ["\n  position: ", ";\n  display: flex;\n  z-index: 35;\n  outline: none;\n  pointer-events: all;\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", "\n"])), function (_a) {
    var isAbsolute = _a.isAbsolute;
    return (isAbsolute ? "absolute" : "fixed");
}, maxHeight, maxWidth, styledTop, styledRight, styledBottom, styledLeft, transform, boxShadow);
export default Container;
var templateObject_1;
